import { PositionStrategy } from './position-strategy';
import { Overlay } from '../overlay';

export class GlobalPositionStrategy implements PositionStrategy {
	private overlayRef: Overlay;
	private cssPosition = 'static';
	private topOffset = '';
	private bottomOffset = '';
	private leftOffset = '';
	private rightOffset = '';
	private alignItems = '';
	private justifyContent = '';
	private width = '';
	private height = '';
	private wrapper: HTMLElement | undefined;

	detach() {}

	attach(overlayRef: Overlay) {
		this.overlayRef = overlayRef;

		if (this.width && !overlayRef.options.width) {
			overlayRef.updateSize({ width: this.width });
		}

		if (this.height && !overlayRef.options.height) {
			overlayRef.updateSize({ height: this.height });
		}
	}

	top(value = '') {
		this.bottomOffset = '';
		this.topOffset = value;
		this.alignItems = 'flex-start';
		return this;
	}

	left(value = '') {
		this.rightOffset = '';
		this.leftOffset = value;
		this.justifyContent = 'flex-start';
		return this;
	}

	bottom(value = '') {
		this.topOffset = '';
		this.bottomOffset = value;
		this.alignItems = 'flex-end';
		return this;
	}

	right(value = '') {
		this.leftOffset = '';
		this.rightOffset = value;
		this.justifyContent = 'flex-end';
		return this;
	}

	centerHorizontally(offset = '') {
		this.left(offset);
		this.justifyContent = 'center';
		return this;
	}

	centerVertically(offset = '') {
		this.top(offset);
		this.alignItems = 'center';
		return this;
	}

	apply() {
		if (!this.overlayRef.attached) {
			return;
		}

		if (!this.wrapper && this.overlayRef.overlayElement.parentNode) {
			this.wrapper = document.createElement('div');
			this.wrapper.classList.add('c-overlay__global');
			this.overlayRef.overlayElement.parentNode.insertBefore(
				this.wrapper,
				this.overlayRef.overlayElement
			);
			this.wrapper.appendChild(this.overlayRef.overlayElement);
		}

		this.overlayRef.overlayElement.style.position = this.cssPosition;
		this.overlayRef.overlayElement.style.marginLeft =
			this.overlayRef.options.width === '100%' ? '0' : this.leftOffset;
		this.overlayRef.overlayElement.style.marginTop =
			this.overlayRef.options.height === '100%' ? '0' : this.topOffset;
		this.overlayRef.overlayElement.style.marginBottom = this.bottomOffset;
		this.overlayRef.overlayElement.style.marginRight = this.rightOffset;

		this.overlayRef.overlayElement.parentElement.style.justifyContent =
			this.overlayRef.options.width === '100%'
				? 'flex-start'
				: this.justifyContent;
		this.overlayRef.overlayElement.parentElement.style.alignItems =
			this.overlayRef.options.height === '100%'
				? 'flex-start'
				: this.alignItems;
	}

	dispose() {
		this.wrapper?.parentNode?.removeChild(this.wrapper);
		this.wrapper = null;
	}
}
